import { em } from 'polished';

export const emValue = (px: number): number => {
    const emWithUnit = em(px);
    return parseInt(emWithUnit.substr(0, emWithUnit.length - 2), 10);
};
